import { Box, Stack } from "@mui/material";
import { UserWithPanTooltip } from "./UserWithPenTooltip";

export const SeniorityBodyCell = ({
  value,
  minWidth,
  maxWidth,
  justifyContent = "space-between",
  isEdited,
}: {
  value: string;
  minWidth: string;
  maxWidth: string;
  isEdited: boolean;
  justifyContent?: "space-between" | "center" | "flex-start" | "flex-end";
}) => {
  return (
    <Stack
      flexDirection="row"
      alignItems="center"
      minWidth={minWidth}
      maxWidth={maxWidth}
      justifyContent={justifyContent}
      width="100%"
      padding="0 16px"
      gap="12px"
    >
      {value && value !== "--" ? (
        <span
          style={{
            borderRadius: "8px",
            padding: "4px 8px",
            fontSize: "14px",
            lineHeight: "18px",
            fontWeight: 550,
            color: "#4C545B",
            border: "1px solid #D9D9D9",
            textAlign: "left",
          }}
        >
          {value}
        </span>
      ) : (
        <Box>--</Box>
      )}
      {isEdited && <UserWithPanTooltip />}
    </Stack>
  );
};
